import React, { FC } from 'react';
import {
    DragDropContext,
    Droppable,
    OnDragEndResponder,
} from 'react-beautiful-dnd';
import { Box, FormControl, List, MenuItem, Select } from '@mui/material';
import DraggableListItem from './DraggableListItem';
import { Item } from '../../Helpers/typings';

export type Props = {
    items: Item[];
    onDragEnd: OnDragEndResponder;
    onHandleOpenDialog: (value: boolean) => void;
};
const DraggableList: FC<Props> = React.memo(({ items, onDragEnd, onHandleOpenDialog }) => {

    const onRowClick = (val) => {
        
        onHandleOpenDialog(val)
    }
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable-list">
                {(provided) => (
                    <List ref={provided.innerRef} {...provided.droppableProps}>
                        {items.map((item: Item, index: number) => (
                            <DraggableListItem item={item} index={index} key={item.id} onRowClickForOpenDialog={onRowClick} />
                        ))}
                        {provided.placeholder}
                    </List>

                )}
            </Droppable>
            <Box style={{ padding: 10, paddingLeft: 20, paddingRight: 20 }}>
                <FormControl fullWidth>
                    <Select
                        name="type"
                        // options={options}
                        // value={selectedOption}
                        // onChange={handleSelectChange}
                        placeholder="Select"
                        size='small'
                        styles={{
                            placeholder: (provided) => ({
                                ...provided,
                                fontSize: '0.813rem',
                            }),
                            control: (base) => ({
                                ...base,
                                backgroundColor: '#FAFBFD',
                                border: '2px solid #cbcbda',
                                '&:hover': {
                                    border: '2px solid #bdc1cd',
                                },
                                boxShadow: 'none',
                            }),
                        }}
                    >
                        <MenuItem value={''}>Select</MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </DragDropContext>
    );
});

export default DraggableList;
